// removed by extract-text-webpack-plugin
module.exports = {"title":"app-components-ImportModal-InformationModal-__InformationModal___Ujczi","dialog":"app-components-ImportModal-InformationModal-__InformationModal___Av2Bs"};


//////////////////
// WEBPACK FOOTER
// ./app/components/ImportModal/InformationModal/InformationModal.css
// module id = 1971
// module chunks = 0